<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Project Charter" @back="back" :backIcon="attendant != '' ? true : false">
            <br>
            <common-training-header :withUser="false"/>
        </a-page-header>

        <div class="text-right" style="margin-bottom: 24px">
            <a-button type="primary" icon="plus" @click="addForm('')" v-if="attendant == ''" :disabled="!proposalRevision"> Tambah </a-button>
        </div>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.charters"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="title" slot-scope="record" style="text-align: left">
                    {{ record.title }}
                </div>

                <div slot="sponsor" slot-scope="record" style="text-align: left">
                    {{ record.sponsor }}
                </div>

                <div slot="objective" slot-scope="record" style="text-align: left">
                    {{ record.objective }}
                </div>

                <div slot="area" slot-scope="record" style="text-align: left">
                    {{ record.scope_of_work }}
                </div>

                <div slot="action" slot-scope="record">
                    <a-space>
                        <a-tooltip title="View Charter">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                icon="eye"
                                @click="charter(record.id)"
                            />
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'title',
            title: 'Judul',
            align: 'center',
            scopedSlots: {customRender: 'title'},
        }, {
            key: 'sponsor',
            title: 'Sponsor',
            align: 'center',
            scopedSlots: {customRender: 'sponsor'}
        }, {
            key: 'objective',
            title: 'Objektif',
            align: 'center',
            scopedSlots: {customRender: 'objective'}
        }, {
            key: 'area',
            title: 'Lingkup Kerja',
            align: 'center',
            scopedSlots: {customRender: 'area'}
        }, {
            key: 'action',
            title: 'Action',
            align: 'center',
            scopedSlots: {customRender: 'action'}
        }
    ]

    export default {
        props: {
            attendant: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                columns,
                items: {
                    charters: [],
                },
                loading: false,
                proposalRevision: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems() {
                this.loading = true;

                let params = {}

                if(this.attendant != ''){
                    params = {
                        attendant: this.attendant
                    }
                }

                this.$http
                    .get(this.routeUri("api.project-management.charter.index"), {
                        params: params
                    })
                    .then(response => {
                        this.items = response.data
                        this.proposalRevision = response.data.proposalRevision
                    })
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            charter(id){
                let params = {
                    charter: id
                }
                window.location.href = this.routeUri('admin.project.charter') + '?' + this.$qs.stringify(params)
            },
            addForm(){
                window.location.href = this.routeUri("admin.project.charter")
            },
            back() {
                window.location.href = this.routeUri('admin.project.scoring.proposal')
            },
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            }
        }
    }
</script>
